import { Tabs, Tab, useTheme } from "@mui/material";

interface LeadsManagementTabsProps {
  view: "leads" | "analytics";
  onChangeView: (view: "leads" | "analytics") => void;
}

export default function LeadsManagementTabs({
  view,
  onChangeView,
}: LeadsManagementTabsProps) {
  const theme = useTheme();
  return (
    <Tabs
      value={view}
      onChange={(_, value) => onChangeView(value)}
      sx={{
        // mt: 2.5,
        borderBottom: 1,
        borderColor: "divider",
        minHeight: 0,
        "& .MuiTab-root": {
          minHeight: 0,
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: "0.4px",
          color: "text.secondary",
        },
        "& .Mui-selected": { color: `${theme.palette.secondary.main} !important` },
        "& .MuiTabs-indicator": { backgroundColor: "secondary.main", height: 2 },
      }}
    >
      <Tab value="leads" label="LEADS"/>
      <Tab value="analytics" label="ANALYTICS" />
    </Tabs>
  );
}
